import { SocketStatus } from '@m43/sockets-mark43';

/**
 * Decides what the narrative socket's `onSocketStatusChange` handler should do
 * for a given status.
 *
 * The socket listener is registered with `invokeOnInitialize: true`, so an
 * already-connected session delivers a `CONNECTED` event synchronously on mount.
 * The initial bootstrap is owned by `reinitializeOnEntityChange` (`reloadPage` on
 * mount), so refetching on that first `CONNECTED` would duplicate it — two
 * identical cursor-less `narrative/list` calls. So the first connect
 * only records that the socket is up; only genuine *re*connects refetch to catch
 * up on messages missed while disconnected.
 */
export type NarrativeSocketConnectAction = 'ignore' | 'mark-initial' | 'refetch';

export function getNarrativeSocketConnectAction(
    status: SocketStatus,
    initialConnectionMade: boolean
): NarrativeSocketConnectAction {
    if (status !== 'CONNECTED') {
        return 'ignore';
    }
    // First connect: bootstrap already handled on mount — just record it.
    // Subsequent connects are reconnects: refetch to catch up.
    return initialConnectionMade ? 'refetch' : 'mark-initial';
}
